import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import { Subscribe } from "unstated";
import { FormattedMessage } from "react-intl";
import { RotateLoader } from "react-spinners";

import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import { myGlobals, myUtilities } from "../../Utils";

class PaymentLoader extends React.Component {
  render() {
    return (
      <Subscribe to={[PaymentDataContainer]}>
        {(data) => (
          <Modal
          backdrop={!myGlobals.currentTheme==="trifectaTheme.css"} 
            show={data.state.loadingPaymentStatus}
            onHide={() => {
              console.log("closed");
            }}
            centered
          >
            <Modal.Body>
              <Container className="payment-check-container payment-loader">
                <Row>
                  <Col className="payment-check-element check-pay-trifecta">
                    <RotateLoader
                      size={15}
                      sizeUnit={"px"}
                      color={"#000000"}
                      loading={true}
                    />
                  </Col>
                    <div className="loading-gif-trifecta"></div>
                </Row>
                <Row>
                  <Col className="payment-check-element">
                  {myUtilities.accountSpecificLanguage(
                    "Payment.Initialising",
                    "Please wait initializing payment"
                  )}
                  </Col>
                </Row>
              </Container>
            </Modal.Body>
          </Modal>
        )}
      </Subscribe>
    );
  }
}

export default PaymentLoader;
